import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import trackingActions, {TrackEventParams} from '../actions/tracking.actions';

export type UseTrackEventProps = TrackEventParams;
export type UseTrackEventType = 'Begin' | 'Success' | 'Fail';

export interface UseTrackEventReturnType {
    begin: (overrides?: Partial<UseTrackEventProps>) => void;
    success: (overrides?: Partial<UseTrackEventProps>) => void;
    fail: (overrides?: Partial<UseTrackEventProps>) => void;
}

const useTrackEvent = (props: UseTrackEventProps) => {
    const dispatch = useDispatch();
    const {eventAction, eventCategory} = props || {};

    return useCallback(
        (type: UseTrackEventType, overrides?: Partial<UseTrackEventProps>) => {
            if (!props) return;
            if (!props.eventAction || !props.eventCategory) {
                if (process.env.NODE_ENV === 'development') {
                    console.error(
                        '[DEV] useTrackEvent - Failed to provide eventAction or eventCategory'
                    );
                }
                return;
            }

            const {data, ...rest} = props;
            let eventAction = props.eventAction;
            if (overrides) {
                eventAction = overrides.eventAction || eventAction;
            }

            dispatch(
                trackingActions.trackCustomEvent(
                    {
                        ...rest,
                        ...overrides,
                        data,
                        eventAction: `${eventAction}${type}`
                    },
                    {prefix: 'data'}
                )
            );
        },
        [dispatch, props, eventAction, eventCategory]
    );
};

export default useTrackEvent;
